module.exports = __webpack_public_path__ + "static/media/scarf.3d8bf16b.svg";